module.exports = __webpack_public_path__ + "static/media/SketchPng5c66b728b2d58f808a24795718001f3c2330120015c02fc18e7c8c98aec3cbf6.b25e6904.png";